import request from '@/utils/httpRequest'

export default class HandoverDocService {
    queryById(id) {
        return request({
            url: '/handover/wuyeHandoverDoc/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    startFlow(params) {
        return request({
            url: '/handover/wuyeHandoverDoc/startFlow',
            method: 'post',
            data: params
        })
    }

}
